import { useMemo } from "react";
import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";

import { DASHBOARD_SECTIONS } from "../../constants/dashboardSections";
import { hasAllPermissions } from "../../redux/selectors/authSelector";

/**
 * Sections the signed-in user is allowed to open, in sidebar order.
 */
export const useAllowedSections = () => {
  const auth = useSelector((state) => state.auth);

  return useMemo(
    () =>
      DASHBOARD_SECTIONS.filter((section) =>
        hasAllPermissions(section.permissions)({ auth })
      ),
    [auth]
  );
};

/**
 * Section matching the current URL exactly, or undefined on a non-section page.
 */
export const useActiveSection = () => {
  const { pathname } = useLocation();

  return useMemo(
    () =>
      DASHBOARD_SECTIONS.find((section) => !!matchPath(section.path, pathname)),
    [pathname]
  );
};

/**
 * Section the sidebar should highlight. Detail screens keep their list
 * highlighted, e.g. /customers/<uuid> stays on "Customers".
 */
export const useHighlightedSection = () => {
  const { pathname } = useLocation();

  return useMemo(
    () =>
      DASHBOARD_SECTIONS.find((section) => !!matchPath(section.path, pathname)) ||
      DASHBOARD_SECTIONS.find(
        (section) => !!matchPath(`${section.path}/*`, pathname)
      ),
    [pathname]
  );
};
